import type { ExpandingMenuLinkProps } from "./types/expanding-menu-link.types";
import { expandingMenuLinkStyles } from "./styles/expanding-menu-link.styles";
import { Slot } from "@radix-ui/react-slot";

export const ExpandingMenuLink: React.FC<ExpandingMenuLinkProps> = (props) => {
  const { children, className, asChild = false, ...rest } = props;

  const styles = expandingMenuLinkStyles({ className });

  const Component = asChild ? Slot : "a";

  return (
    <Component className={styles} {...rest}>
      {children}
    </Component>
  );
};

ExpandingMenuLink.displayName = "ExpandingMenuLink";
